import { GroupsTab, type GroupsTabProps } from '@ardoq/perspectives-sidebar';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { connect } from '@ardoq/rxbeach';
import { groupsTab$ } from 'perspectiveSidebar/perspectiveEditor/groupsTab$';
import { ViewOptionsPerspectivesPage as ViewOptionsPerspectivesPageBase } from './ViewOptionsPerspectivesPage';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

type ViewOptionsPerspectivesGroupsProps = GroupsTabProps & {
  onClickOutside?: VoidFunction;
};

const ViewOptionsPerspectivesGroupsBase = ({
  onClickOutside,
  i18nLocale,
  ...props
}: ViewOptionsPerspectivesGroupsProps) => (
  <ViewOptionsPerspectivesPageBase
    title={t(i18nLocale, 'appLayout:groupsPageTitle', 'Groups')}
    knowledgeBaseLink={KnowledgeBaseLink.GROUPING_RULES}
    onClickOutside={onClickOutside}
  >
    <GroupsTab {...props} i18nLocale={i18nLocale} />
  </ViewOptionsPerspectivesPageBase>
);

export const ViewOptionsPerspectivesGroups = connect(
  ViewOptionsPerspectivesGroupsBase,
  combineLatest([groupsTab$, i18nLocale$]).pipe(
    map(([props, i18nLocale]) => ({ ...props, i18nLocale }))
  )
);
